import { z } from "zod";
import { lotInputSchema } from "./lot";

/**
 * Шаблоны заявок (раздел 16.5): название + поля формы лота, кроме дат (loadingAt, deadlineAt).
 * Поля необязательные — шаблон может задавать только маршрут или только груз; в форме «Новая заявка»
 * кнопка «Из шаблона» заполняет то, что в шаблоне есть, даты остаются пустыми.
 */
export const lotTemplateFieldsSchema = lotInputSchema.omit({ loadingAt: true, deadlineAt: true }).partial();
export type LotTemplateFields = z.infer<typeof lotTemplateFieldsSchema>;

export const LOT_TEMPLATE_NAME_MAX = 120;

export const lotTemplateInputSchema = z.object({
  name: z.string().trim().min(1, "Введите название").max(LOT_TEMPLATE_NAME_MAX),
  fields: lotTemplateFieldsSchema.default({}),
});
export type LotTemplateInput = z.infer<typeof lotTemplateInputSchema>;

export const lotTemplatePatchSchema = z.object({
  name: z.string().trim().min(1, "Введите название").max(LOT_TEMPLATE_NAME_MAX).optional(),
  fields: lotTemplateFieldsSchema.optional(),
  isActive: z.boolean().optional(),
});
export type LotTemplatePatch = z.infer<typeof lotTemplatePatchSchema>;

/** Строка GET /api/lot-templates. Даты — ISO-строки. */
export type LotTemplate = {
  id: string;
  name: string;
  fields: LotTemplateFields;
  isActive: boolean;
  createdBy: string;
  createdByName: string | null;
  createdAt: string;
};
